/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import Skeletonui from '../Components/Skeletonui'
import { useState, useEffect } from "react";
import Iframe from 'react-iframe'
import Navbarsection from '../views/Home/Navbarsection';
import Categoryslides from '../views/Home/Categoryslides';
import ScrollToTop from "react-scroll-to-top"; 

const Searchanything = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 6000);
    }, []);
    
    return (
        <>
         <ScrollToTop smooth className="bg-none pl-[15px] pr-[44px]" color="blue" />
        <Navbarsection/>
        <Categoryslides/>
        <div className="">

       
{loading ? <Skeletonui />  :  <Iframe url="https://sitekitpro.com/SITEKITPROREACT/catlog/all-sitekit-themes/index.html"
   width="100%"
   height="900px" 
   display="block"
   position="relative"/>   }

  {/*  Dextop Only  */}
   
 </div>
        </>
    );
}

export default Searchanything;
